import { AppBar, Toolbar, IconButton, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import Dot from "../../components/Dot";
import MenuIcon from "@mui/icons-material/Menu";
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar
} from "../../context/LayoutContext";
import {
  useUserState,
  logOut,
  useUserDispatch
} from "../../context/UserContext";
import classNames from "classnames";
import { useTheme } from "@mui/material/styles";
import logo from "../../assets/images/logo.svg";
// styles
import useStyles from "./styles";
import { useEffect, useRef, useState } from "react";
import { httprequest } from "../../data/api";
import PageLoader from "../PageLoader";
import { toast } from "react-toastify";
import Button from "../Button";
import Modal from "../Modal/index";
import { useWard } from "../../context/GaurdianContext";
import SelectGroup from "../FormComponent/SelectGroup";

// All Notification
const ALL_NOTIFICATION = "/api/v1/notifications";
const PROFILE_ENDPOINT = "/api/v1/auth/profiles";
const PROFILE_SELECT_ENDPOINT = "/api/v1/auth/switch-profile";

const extractSnippetFromHTML = (html) => {
  // Extract title
  const titleMatch = html.match(/<title[^>]*>([^<]+)<\/title>/i) ||
                    html.match(/<h\d[^>]*>([^<]+)<\/h\d>/i) ||
                    html.match(/<p[^>]*class=["']?template-heading["']?[^>]*>([^<]+)<\/p>/i) ||
                    html.match(/FINAL REMINDER: ([^<]+)/i) ||
                    html.match(/<strong[^>]*>([^<]+)<\/strong>/i);

  const title = titleMatch ? titleMatch[1].trim() : "Notification";

  let snippet = "";

  const contentMatch = html.match(/<div[^>]*class=["']?section-body["']?[^>]*>([\s\S]*?)<\/div>/i) ||
                      html.match(/<section[^>]*>([\s\S]*?)<\/section>/i) ||
                      html.match(/Dear[^<]*<p>([\s\S]*?)<p>Best regards/i);

  if (contentMatch) {
    snippet = contentMatch[1]
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    snippet = snippet
      .replace(/^Dear\s+\w+,?\s*/i, "")
      .replace(/\s*Best regards.*$/i, "")
      .replace(/\s*If you see any suspicious activity.*$/i, "")
      .trim();
  } else {
    snippet = html
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .substring(0, 100);
  }

  snippet = snippet.length > 40 ? `${snippet.substring(0, 40)}...` : snippet;

  return {
    title,
    body: html,
    snippet: snippet || "Click to view details"
  };
};

const parseMessageContent = (message) => {
  try {
    const parsed = JSON.parse(message);

    return {
      title: parsed.title || "Notification",
      body: parsed.body || message,
      snippet: parsed.body ?
        (parsed.body.length > 40 ? `${parsed.body.substring(0, 40)}...` : parsed.body)
        : ""
    };
  } catch (error) {
    return extractSnippetFromHTML(message);
  }
};

const Header = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { appLogo, profile, userRole, subscription } = useUserState();
  const [anchorEl, setAnchorEl] = useState();
  const notificationTab = Boolean(anchorEl);
  const [allNotification, setAllNotification] = useState([]);
  const [unReadNotifications, setUnReadNotifications] = useState([]);
  const [isNotificationFetching, setIsNotificationFetching] = useState(false);
  const { isSidebarOpened } = useLayoutState();
  const theme = useTheme();
  const windowWidth = window.innerWidth;
  const breakpointWidth = theme.breakpoints.values.md;
  const isSmallScreen = windowWidth < breakpointWidth;
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [demoDrop, setDemoDrop] = useState(false);
  const userDispatch = useUserDispatch();
  const [clearDemoModal, setClearDemoModal] = useState(false);
  const [isClearing, setIsClearing] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [currentSubcription, setCurrentSubcription] = useState([]);
  const [wardModalOpen, setWardModalOpen] = useState(false);
  const [tempSelectedWard, setTempSelectedWard] = useState(null);
  const { wards, changeWard, selectedWard } = useWard();
  const isMobile = useMediaQuery(theme.breakpoints.down(450));
  const wardDropdownRef = useRef(null);

  // Profile/School Selection States
  const [schoolModalOpen, setSchoolModalOpen] = useState(false);
  const [roleModalOpen, setRoleModalOpen] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMultipleRoles, setHasMultipleRoles] = useState(false);

  const handleClearDemoModal = () => {
    setClearDemoModal(!clearDemoModal);
  };

  const handleCloseNotification = () => {
    setAnchorEl(null);
  };

  const handleDemoDrop = () => {
    setDemoDrop(!demoDrop);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const layoutDispatch = useLayoutDispatch();

  const handleNotificationClicked = (notification) => {
    navigate(`/notifications?selected=${notification.id}`);
    handleCloseNotification();

    if (!notification.read) {
      const updatedNotifications = allNotification.map((n) => n.id === notification.id ? { ...n, read: true } : n
      );
      setAllNotification(updatedNotifications);
      setUnReadNotifications(updatedNotifications.filter(notif => !notif.read));

      httprequest.patch(`${ALL_NOTIFICATION}/${notification.id}`, { read: true })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error("Failed to mark notification as read:", err);
        });
    }
  };

  const handleLogout = () => {
    logOut(userDispatch, navigate);
    handleCloseNavMenu();
    toast.success("Logged out successfully");
  };

  const handleClickNotificationIcon = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getAllNotifications = () => {
    setIsNotificationFetching(true);
    httprequest
      .get(ALL_NOTIFICATION)
      .then((res) => {
        setIsNotificationFetching(false);

        const notifications = res?.data?.data?.items || [];
        const safeNotifications = Array.isArray(notifications) ? notifications : [];

        setAllNotification(safeNotifications);
        setUnReadNotifications(safeNotifications.filter((notif) => !notif?.read));
      })
      .catch((err) => {
        setIsNotificationFetching(false);
        toast.error(err?.response?.data);
        setAllNotification([]);
        setUnReadNotifications([]);
      });
  };

  const handleClearDemoData = () => {
    setIsClearing(true);
    httprequest
      .delete("/api/v1/lulu")
      .then((res) => {
        toast.success(res.data.message);
        setDemoDrop(false);
        setClearDemoModal(false);
        setIsClearing(false);
        window.location.reload();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Failed to clear demo data"
        );
        setIsClearing(false);
      });
  };

  const handleTempWardChange = (wardId) => {
    const ward = wards.find(w => w.id === wardId);
    setTempSelectedWard(ward);
  };

  const handleConfirmWardSelection = () => {
    if (tempSelectedWard) {
      changeWard(tempSelectedWard.id);
      setWardModalOpen(false);
      toast.success(`Now viewing ${tempSelectedWard.first_name}'s dashboard`);
      setTempSelectedWard(null);
    } else {
      toast.warning("Please select a ward first");
    }
  };

  const handleCloseWardModal = () => {
    setWardModalOpen(false);
    setTempSelectedWard(null);
  };

  const handleWardSelect = (ward) => {
    changeWard(ward.id);
    setDemoDrop(false);
    toast.success(`Now viewing ${ward.first_name}'s dashboard`);
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const getFirstLetter = (name) => {
    return name ? name.charAt(0).toUpperCase() : "";
  };

  const account = profile
    ? {
      id: profile.school_id,
      name: profile.school_name || `${profile.first_name} ${profile.last_name}`,
      role: profile.role?.name?.replace("_", " "),
      active: true
    }
    : null;

  // Fetch profiles (schools with their roles)
  const getProfileData = () => {
    setIsLoading(true);
    httprequest.get(PROFILE_ENDPOINT)
      .then(res => {
        const profilesData = res.data.data || [];
        setProfiles(profilesData);

        const hasMultipleSchools = profilesData.length > 1;

        const allRoleTypes = profilesData.flatMap(profile => profile.roles?.map(role => role.role_type) || []
        );
        const uniqueRoleTypes = [...new Set(allRoleTypes)];

        setHasMultipleRoles(hasMultipleSchools || uniqueRoleTypes.length > 1);
      })
      .catch(err => {
        toast.error(err.response?.data?.message || "Failed to load profiles");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handle profile/role selection
  const handleProfileSelection = async (profileId) => {
    setIsLoading(true);
    try {
      const response = await httprequest.post(PROFILE_SELECT_ENDPOINT, {
        profile_id: profileId
      });

      toast.success(response?.data?.message || "Profile switched successfully");
      localStorage.removeItem("shelf21-auth");
      setRoleModalOpen(false);
      localStorage.setItem("shelf21-auth", response.data.token);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to switch profile");
    } finally {
      setIsLoading(false);
    }
  };

  // Open school selection modal
  const handleOpenSchoolSelection = () => {
    getProfileData();
    setSchoolModalOpen(true);
    handleCloseNavMenu();
  };

  const renderRoleIcon = (roleName, isSelected = false) => {
    const name = roleName?.toLowerCase() || "";
    const color = isSelected ? "#0d6efd" : "#666";

    if (name.includes("admin")) {
      return <Icon icon="mdi:shield-account" width="48" height="48" color={color} />;
    }
    if (name.includes("staff") || name.includes("teacher")) {
      return <Icon icon="mdi:human-male-board" width="48" height="48" color={color} />;
    }
    if (name.includes("student")) {
      return <Icon icon="mdi:account-school" width="48" height="48" color={color} />;
    }
    if (name.includes("parent") || name.includes("guardian")) {
      return <Icon icon="mdi:account-child" width="48" height="48" color={color} />;
    }

    return <Icon icon="mdi:account-group" width="48" height="48" color={color} />;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wardDropdownRef.current &&
      !wardDropdownRef.current.contains(event.target)
      ) {
        setDemoDrop(false);
      }
    };

    if (demoDrop) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [demoDrop]);

  useEffect(() => {
    getAllNotifications();
    getProfileData();
  }, []);

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.logotype}>
          <img src={appLogo || logo} alt="App logo" className={classes.logo} />
        </div>
        {process.env.REACT_APP_ENVIRONMENT === "development" ? (
          <div className={classes.environment}>Dev</div>
        ) : process.env.REACT_APP_ENVIRONMENT === "staging" ? (
          <div className={classes.environment}>staging</div>
        ) : process.env.REACT_APP_ENVIRONMENT === "sandbox" ? (
          <div className={classes.environment}>sandbox</div>
        ) : null}
        <Icon icon="icon-park-outline:avatar" />

        <div className="flex gap-10">
          {userRole?.role_type === "school_admin" ?
            <div onClick={() => navigate("/settings?tab=subscription")}
              className={classes.plan}
            >
              <p className={classes.planText}>
                {subscription?.pricing_plan?.name || "Basic Plan" }
                <span
                  className={classes.planSubText}
                  style={{ cursor: "pointer" }}
                >
                  View Plan
                </span>
              </p>
            </div> : null}
          {userRole?.role_type === "guardian" && (
            selectedWard && (
              <div onClick={handleDemoDrop} className={classes.demo} ref={wardDropdownRef}>

                <span style={{ display: "flex", padding: "8px", alignItems: "center", gap: "8px", fontSize: "14px" }}>
                  {!isMobile && (
                    selectedWard ? `${selectedWard.first_name} ${selectedWard.last_name}` : "Loading..."
                  )}
                  <Icon icon="fluent-mdl2:switch-user" width="18" height="18" />
                </span>

                {demoDrop && (
                  <div className={classes.warddropdown}>
                    <div>
                      <p className={classes.demoText}>Select Ward</p>
                      {wards.map((ward) => (
                        <h3
                          key={ward.id}
                          className={classes.ward_div}
                          onClick={() => handleWardSelect(ward)}
                          style={{ cursor: "pointer" }}
                        >
                          <span className={classes.wardInitial}>
                            {getFirstLetter(ward.first_name)}
                          </span>

                          {ward.first_name} {ward.last_name} - {ward.class_name}
                          {selectedWard?.id === ward.id ? " (Current)" : ""}
                        </h3>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )
          )}
          {profile?.demo_data && userRole?.role_type === "school_admin" && (
            <div onClick={handleDemoDrop} className={classes.demo}>
              {profile?.demo_data?.days_remaining}
              {demoDrop && (
                <div className={classes.demodropdown}>
                  <span className={classes.closeIcon} onClick={handleDemoDrop}>
                    {" "}
                    <Icon
                      color="black"
                      icon="mdi:close-circle"
                      width="24"
                      height="24"
                    />
                  </span>
                  <div className={classes.demoleft}>
                    <p className={classes.demoText}>Demo data clears in</p>
                    <h3 className={classes.demoNum}>{profile?.demo_data?.days_remaining} days</h3>
                  </div>
                  <Button
                    variant="primaryoutline"
                    buttonSize="fluid"
                    color="btnfontprimary"
                    buttonName="Clear"
                    onClick={handleClearDemoModal}
                  />
                </div>
              )}
            </div>
          )}

          <IconButton
            color="inherit"
            aria-haspopup="true"
            aria-controls="mail-menu"
            open={notificationTab}
            aria-expanded="false"
            onClick={handleClickNotificationIcon}
            className={classes.headerMenuButton}
            style={{ padding: 0 }}
          >
            <div className={classes.alertbadge}>
              {unReadNotifications?.length || 0}
            </div>
            <div className={classes.initials}>
              <Icon icon="iconamoon:notification-bold" width="17" height="17" />
            </div>
          </IconButton>
          <IconButton
            size="large"
            aria-label="navigation menu"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
            style={{ padding: 0 }}
            className={classes.headerMenuButton}
          >
            <div className={classes.initials}>
              <Icon
                icon="iconamoon:profile"
                width="17"
                height="17"
              />
            </div>
          </IconButton>
          <>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.headerProfileMenu}
              PaperProps={{
                sx: {
                  minWidth: "220px"
                }
              }}
            >
              <div className={classes.accountWrapper}>
                {account && (
                  <div key={account.id} className={classes.accountItem}>
                    <div className={classes.avatarCircle}>
                      {profile?.display_pic?.file_url ? (
                        <img
                          src={profile.display_pic.file_url}
                          alt={account.name}
                          className={classes.avatarImage}
                        />
                      ) : (
                        getFirstLetter(account.name)
                      )}
                    </div>

                    <div className={classes.accountInfo}>
                      <p className={classes.accountName}>{account.name}</p>
                      <span className={classes.accountRole}>{account.role}</span>
                    </div>

                    {account.active && <span className={classes.activeDot} />}
                  </div>
                )}

                {hasMultipleRoles && (
                  <button
                    className={classes.switchAccountBtn}
                    onClick={handleOpenSchoolSelection}
                  >
                    <Icon icon="ph:user-switch-light" width="18" height="18" />
                    <span>Switch Account</span>
                  </button>
                )}
              </div>

              <div className={classes.menuDivider} />

              <MenuItem
                onClick={() => {
                  navigate("/support/tickets");
                  handleCloseNavMenu();
                }}
                className={classes.headerMenuItem}
              >
                <Icon icon="tabler:message" width="17" />
                <span style={{ marginLeft: "10px" }}>Support</span>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/site-map");
                  handleCloseNavMenu();
                }}
                className={classes.headerMenuItem}
              >
                <Icon icon="ic:round-dashboard" width="17" />
                <span style={{ marginLeft: "10px" }}>Site Map</span>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/profile");
                  handleCloseNavMenu();
                }}
                className={classes.headerMenuItem}
              >
                <Icon icon="iconamoon:profile" width="17" />
                <span style={{ marginLeft: "10px" }}>My Profile</span>
              </MenuItem>

              {/* <MenuItem
                onClick={() => {
                  navigate("/add-account");
                  handleCloseNavMenu();
                }}
                className={classes.headerMenuItem}
              >
                <Icon icon="mdi:account-plus-outline" width="17" />
                <span>Add Account</span>
              </MenuItem> */}

              <MenuItem
                onClick={handleLogout}
                className={classNames(classes.headerMenuItem, classes.logoutMenuItem)}
              >
                <Icon icon="majesticons:logout-line" width="17" color="red" />
                <span style={{ marginLeft: "10px" }}>Logout</span>
              </MenuItem>
            </Menu>

          </>
          <Menu
            id="notifications-menu"
            open={notificationTab}
            anchorEl={anchorEl}
            onClose={handleCloseNotification}
            className={classes.headerMenu}
            disableAutoFocusItem
          >
            <MenuItem>
              <div
                className={`${classes.notifyheader} flex gap-10 align-items-center justify-items-space`}
              >
                <h3 style={{ fontSize: "16xp" }}>Notification</h3>
                <div className={classes.notificationbadge}>
                  {unReadNotifications?.length} unread
                </div>
              </div>
            </MenuItem>
            {isNotificationFetching ? (
              <PageLoader />
            ) : (
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {!Array.isArray(allNotification) || allNotification?.length === 0 ? (
                  <MenuItem className={classes.headerMenuItem}>
                    <div className={classes.noNotifications}>
                      No notifications found
                    </div>
                  </MenuItem>
                ) : (
                  Array.isArray(allNotification) && allNotification
                    ?.sort((a, b) => (a.read === b.read ? 0 : a.read ? 1 : -1))
                    ?.slice(0, 5)
                    ?.map((notification) => {
                      const Activity = notification?.read ? (
                        <Dot size="small" color="#98A2B3" />
                      ) : (
                        <Dot size="small" color="green" />
                      );

                      const messageContent = parseMessageContent(notification.message);
                      const displayTitle = notification.title || messageContent.title;
                      const snippet = messageContent.snippet || "Click to view details";

                      return (
                        <MenuItem
                          key={notification.id}
                          disableRipple
                          onClick={() => handleNotificationClicked(notification)}
                          className={classes.headerMenuItem}
                          style={{
                            justifyContent: "space-between",
                            borderBottom: "1px solid #f0f0f0",
                            padding: "12px 16px"
                          }}
                        >
                          <div className={`${classes.notifyitems}`}>
                            <div className="flex justify-items-space align-items-center flex-wrap-items-426 w-100">
                              <div className={`${classes.flexresponsive}`}>
                                <div className={classes.notifyheader}>{displayTitle}</div>
                                <div className={classes.notifyBody}>{snippet}</div>
                                <p className={classes.notificationDate}>
                                  {notification?.created_at?.substring(0, 10)}
                                </p>
                              </div>
                              <div className={`${classes.notificationtime}`}>
                                <div className="margin-left">{Activity}</div>
                              </div>
                            </div>
                          </div>
                        </MenuItem>
                      );
                    })
                )}
              </div>
            )}
            <MenuItem style={{ justifyContent: "flex-end", borderTop: "1px solid #e0e0e0" }}>
              <div
                onClick={() => {
                  navigate("/notifications");
                  handleCloseNotification();
                }}
                className={`${classes.notifyfooter} flex gap-10 align-items-center justify-flex-end`}
                style={{ cursor: "pointer", padding: "8px 0" }}
              >
                <p style={{ color: "#0065FF", fontWeight: "500" }}>See all notifications</p>
                <div>
                  <Icon
                    icon="clarity:notification-solid"
                    width="17"
                    height="17"
                    color="#0065FF"
                  />
                </div>
              </div>
            </MenuItem>
          </Menu>
          {isSmallScreen && !isSidebarOpened && (
            <div className={classes.mobileBackButton}>
              <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
                <MenuIcon
                  classes={{
                    root: classNames(
                      classes.headerIcon,
                      classes.headerIconCollapse
                    )
                  }}
                />
              </IconButton>
            </div>
          )}
        </div>
      </Toolbar>
      <Modal
        title="Clear Demo Data"
        subtitle={
          <div>Are you sure you want to clear all demo data? This action cannot be undone.</div>
        }
        modalFooter={
          <>
            <Button
              variant="primary"
              buttonSize="full"
              color="btndefault"
              buttonName="Clear Demo Data"
              isLoading={isClearing}
              onClick={handleClearDemoData}
            />
          </>
        }
        isopen={clearDemoModal}
        closeModal={handleClearDemoModal}
      />

      {/* Ward Selection Modal */}
      <Modal
        title="Select Ward"
        subtitle="Choose which ward's dashboard to view"
        isopen={wardModalOpen}
        closeModal={handleCloseWardModal}
        modalContent={
          <div className={classes.wardModalContent}>
            <p>Select a ward to view their dashboard:</p>
            <SelectGroup
              label=""
              children={
                <select
                  value={tempSelectedWard?.id || selectedWard?.id || ""}
                  onChange={(e) => {
                    if (e.target.value) {
                      handleTempWardChange(e.target.value);
                    }
                  }}
                  className={classes.wardSelect}
                >
                  <option value="">Select a ward</option>
                  {wards.map((ward) => (
                    <option key={ward.id} value={ward.id}>
                      {ward.first_name} {ward.last_name} - {ward.class_name}
                      {selectedWard?.id === ward.id ? " (Current)" : ""}
                    </option>
                  ))}
                </select>
              }
            />
            {tempSelectedWard && (
              <div className={classes.selectedWardPreview}>
                <p><strong>Selected:</strong> {tempSelectedWard.first_name} {tempSelectedWard.last_name} - {tempSelectedWard.class_name}</p>
              </div>
            )}
          </div>
        }
        modalFooter={
          <div className="flex gap-10">
            <Button
              variant="primaryoutline"
              buttonName="Cancel"
              buttonSize="full"
              color="btnfontprimary"
              onClick={handleCloseWardModal}
            />
            <Button
              variant="primary"
              buttonName="Confirm Selection"
              buttonSize="full"
              color="btndefault"
              onClick={handleConfirmWardSelection}
              disabled={!tempSelectedWard}
            />
          </div>
        }
      />

      {/* School Selection Modal */}
      <Modal
        title="Switch Account"
        subtitle="Select a school to switch to"
        isopen={schoolModalOpen}
        closeModal={() => setSchoolModalOpen(false)}
        modalContent={
          <div className={classes.selectionList} style={{ marginBottom: 0 }}>
            {profiles.map((school) => (
              <div
                key={school?.school_id}
                className={`${classes.selectionCard} ${
                  selectedSchool?.school_id === school.school_id ? classes.selectionCardActive : ""
                }`}
                onClick={() => setSelectedSchool(school)}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div className={classes.cardIconWrapper}>
                    <Icon icon="solar:user-bold" width="24" height="24" />
                  </div>
                  <div className={classes.cardInfo}>
                    <h3 className={classes.cardInfoTitle}>{school?.school_name}</h3>
                  </div>
                </div>
                <div className={classes.cardArrow}>
                  <Icon icon="lsicon:arrow-right-filled" width="24" height="24" />
                </div>
              </div>
            ))}
          </div>
        }
        modalFooter={
          <div className="flex gap-10">
            <Button
              variant="primary"
              buttonName="Continue"
              buttonSize="full"
              color="btndefault"
              onClick={() => {
                setSchoolModalOpen(false);
                setRoleModalOpen(true);
              }}
            />
          </div>
        }
      />

      {/* Role Selection Modal */}
      <Modal
        title={`Select Role for ${selectedSchool?.school_name || "School"}`}
        subtitle="Choose a role to switch to"
        isopen={roleModalOpen}
        closeModal={() => setRoleModalOpen(false)}
        modalContent={
          <div className={classes.roleGrid} style={{ marginBottom: 0 }}>
            {selectedSchool?.roles.map((role) => (
              <div
                key={role.id}
                className={`${classes.roleCard} ${
                  selectedRole?.id === role.id ? classes.roleCardSelected : ""
                }`}
                onClick={() => setSelectedRole(role)}
              >
                <div className={classes.cardContent}>
                  <div className={classes.roleIconWrapper}>
                    {renderRoleIcon(role?.role_name, selectedRole?.id === role.id)}
                  </div>
                  <span className={classes.roleName}>{role?.role_name}</span>
                </div>

                <div className={classes.roleArrow}>
                  <Icon icon="mdi:arrow-right" width="20" height="20" />
                </div>
              </div>

            ))}
          </div>
        }
        modalFooter={
          <div className="flex gap-10">
            <Button
              variant="primaryoutline"
              buttonName="Back"
              buttonSize="full"
              color="btnfontprimary"
              onClick={() => {
                setRoleModalOpen(false);
                setSchoolModalOpen(true);
              }}
            />
            <Button
              variant="primary"
              buttonName="Switch Role"
              buttonSize="full"
              color="btndefault"
              isLoading={isLoading}
              onClick={() => {
                if (selectedRole) {
                  handleProfileSelection(selectedRole.id);
                } else {
                  toast.warning("Please select a role first");
                }
              }}
              disabled={!selectedRole || isLoading}
            />
          </div>
        }
      />
    </AppBar>
  );
};

export default Header;
